import { createSlice } from "@reduxjs/toolkit";
import { FilterStateAccountingAccount } from "./types";

const INITIAL_STATE: FilterStateAccountingAccount = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const accountingAccountFilterSlice = createSlice({
  name: "accountingAccountFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setAccountingAccountFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setAccountingAccountFilter } =
  accountingAccountFilterSlice.actions;
export default accountingAccountFilterSlice.reducer;
